import { Dict } from './../core/core-types';

export function toCamelCase(str: string): string {
    return str.replace(/-([a-z])/gi, ($0, $1) => $1.toUpperCase());
}

export function toDashCase(str: string): string {
    return (str.charAt(0) + str.slice(1).replace(/([A-Z])/g, '-$&')
    ).toLowerCase();
}

export function indexBy<K extends keyof O, O>(key: K, arr: O[]): Map<O[K], O> {
    return arr.reduce((indexed, obj) => {
        indexed.set(obj[key], obj);
        return indexed;
    }, new Map());
}

let elementGuid: number = 1000;

export function createGuid(length : number  = 4): number {
    return elementGuid++;
}

export function pick(props: string[], obj: { [key: string]: any }): { [key: string]: any } {
    return props.reduce((memo, prop) => {
        if (prop in obj) {
            return {
                ...memo,
                [prop]: obj[prop]
            };
        }

        return memo;
    }, {}) as any;
}

export function objectsAreEqual(obj1: Dict<any>, obj2: Dict<any>): boolean {
    let equal = true;
    const obj1Keys = Object.keys(obj1);
    const obj2Keys = Object.keys(obj2);

    if (obj1Keys.length !== obj2Keys.length) {
        return false;
    }

    obj1Keys.forEach(key => {
        if (!obj2.hasOwnProperty(key) || obj1[key] !== obj2[key]) {
            equal = false;
        }
    });

    return equal;
}